import { render, staticRenderFns } from "./assessment_question.vue?vue&type=template&id=1988e402&"
import script from "./assessment_question.vue?vue&type=script&lang=js&"
export * from "./assessment_question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports